module.exports = __webpack_public_path__ + "static/media/brand-info-4.745ca8b3.png";